import type { AtlasMission } from '../atlas.types';

export const settingsMission: AtlasMission = {
  id: 'wire-integrations',
  title: 'Wire integrations for this product',
  description: 'Connect Jira so Analytics, Forecast, and Reports light up.',
  kicker: 'Guided tour',
  estimatedMinutes: 5,
  entryRoute: '/settings?tab=project',
  featureKey: 'atlas.wireIntegrations',
  storage: 'atlas',
  critical: true,
  steps: [
    {
      id: 'org-jira',
      title: 'Set the Jira domain and account',
      body: 'Relix reads Jira via an API token tied to a user account. In Project Settings, enter your Atlassian domain (e.g. your-company.atlassian.net) and the email of the service account that owns the token.',
      anchorId: 'settings-org-jira-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'product-jira',
      title: 'Pick the project key for this product',
      body: 'Each product maps to one Jira project. In Per-product integrations below, use the short prefix from issue ids (e.g. PROJ from PROJ-123). Analytics, Forecast, and Reports all filter by this key.',
      anchorId: 'settings-product-jira-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'sharepoint',
      title: 'SharePoint calendar (optional)',
      body: 'If you use SharePoint for team calendars, configure it per product later from the Calendar page. You can skip this step — the rest of Relix works without SharePoint.',
      primaryLabel: 'Next →',
    },
    {
      id: 'test-save',
      title: 'Save the Jira connection',
      body: 'Click Save Jira connection in Project Settings to persist the domain, token and project key. Once saved, data sync unlocks and Atlas marks this mission complete.',
      anchorId: 'settings-test-anchor',
      primaryLabel: 'Done',
    },
  ],
};
